import React from 'react';
import Heading from 'components/Heading';
import Box from 'components/Box';
import Flex from 'components/Flex';
import WeekFilter from 'components/WeekFilter';
import HintTooltip from 'components/HintTooltip';
import PercentageDisc from 'components/PercentageDisc';
import HelixInfoButton from './HelixInfoButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function HeadingWithFilter(_ref) {
  var _ref$showScore = _ref.showScore,
    showScore = _ref$showScore === void 0 ? false : _ref$showScore,
    score = _ref.score,
    _ref$weeks = _ref.weeks,
    weeks = _ref$weeks === void 0 ? [] : _ref$weeks,
    selected = _ref.selected,
    title = _ref.title,
    tooltipContent = _ref.tooltipContent,
    setWeekCommencing = _ref.setWeekCommencing;
  return /*#__PURE__*/_jsx(Box, {
    my: "s",
    children: /*#__PURE__*/_jsxs(Flex, {
      gap: "xxs",
      breakpoints: "xs",
      flexDirection: ['column-reverse', 'row'],
      justifyContent: "space-between",
      alignItems: ['left', 'center'],
      children: [/*#__PURE__*/_jsxs(Flex, {
        breakpoints: "xs",
        flexDirection: ['column', 'row'],
        gap: [0, 's'],
        alignItems: ['left', 'center'],
        width: ['100%', 'auto'],
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          gap: "xxs",
          alignItems: "center",
          my: ['xxs', 0],
          children: [showScore && /*#__PURE__*/_jsx(PercentageDisc, {
            shady: true,
            percentage: score
          }), /*#__PURE__*/_jsx(Heading, {
            ml: showScore ? 'xs' : null,
            as: "h2",
            children: title
          }), tooltipContent && /*#__PURE__*/_jsx(HintTooltip, {
            content: tooltipContent
          })]
        }), /*#__PURE__*/_jsx(WeekFilter, {
          showTitle: false,
          selected: selected,
          weekDates: weeks,
          onChange: function onChange(newWeek) {
            return setWeekCommencing(newWeek);
          }
        })]
      }), /*#__PURE__*/_jsx(HelixInfoButton, {})]
    })
  });
}
export default HeadingWithFilter;